import axios from 'axios'
import Vue from 'vue'

let requestIpConfirm = function(callBack) {
  console.log('资源加载失败')
}

export default function getIpConfigJSON () {
  return new Promise((resolve) => {
    Vue.prototype.$IpConfig = {}
    if (process.NODE_ENV === 'development') {
      axios.get('../static/ipConfig.json').then((response) => {
        if (response.status === 200 || response.status === 304) {
          resolve(response.data)
          return
        }
        requestIpConfirm(getIpConfigJSON)
      })
    } else {
      axios.get('./static/ipConfig.json').then((response) => {
        if (response.status === 200 || response.status === 304) {
          resolve(response.data)
          return
        }
        requestIpConfirm(getIpConfigJSON)
      })
    }
  })
}


// 老版本
// if (process.env.NODE_ENV === 'development') {
    //   axios.get('./ipConfig.json').then(result => {

    //     if (result.status === 200 || result.status === 304) {
    //       resolve(result.data)
    //       console.log(result, 'result')
    //       return
    //     }
    //     console.log(result, 'result123465')
    //     Message.error('网络错误，请重试！')
    //     // const { baseUrl } = result.data
    //     // axios.defaults.baseURL = baseUrl
    //     // Vue.prototype.$IpConfig = result.data
    //     // resolve(true)
    //   })
    // } else {
    //   axios.get('./IpConfig.json').then(result => {
    //     if (result.status === 200 || result.status === 304) {
    //       resolve(result.data)
    //       return
    //     }
    //     Message.error('网络错误，请重试！')
    //   })
    //   // const { baseUrl } = IpConfig
    //   // axios.defaults.baseURL = baseUrl
    //   // Vue.prototype.$IpConfig = IpConfig
    //   // resolve(true)
    // }



// WEBPACK FOOTER //
// ./src/utils/getIpConfig.js